<template>
  <div class="login-to-jira d-flex align-items-center justify-content-between">
    <p class="mb-0">
      <slot name="text"></slot>
    </p>
    <b-button v-if="!isJiraAuth" class=" button" variant="primary" @click="logInToJira">Login to Jira</b-button>
    <div v-else class="d-flex">
      <img
        alt="Jira status: logged in"
        src="/images/jira_logo.svg"
        style="width: 24px"
        title="Jira: logged in"/>
      <p class="mb-0 ml-1">{{ getUser.name }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LogTimeLoginToJira'
}
</script>

<style lang="scss" scoped>
.login-to-jira {
  margin-top: 5px;
  margin-bottom: 10px;

  p {
    font-size: 18px;
    font-weight: 500;
    color: $fontColorBase;
  }

  button {
    width: 180px;
    display: flex;
    justify-content: center;
  }
}
</style>
